// extracted by mini-css-extract-plugin
export default {"container":"WordCloud_container__MgqVs"};